module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_extra_rect_mask.76c616b0.png";